<template>
  <div class="d-flex flex-column fill-height">
    <HeaderLeftContainer :title="$t('views.leftBar.createIncident')" :back-to="{ name: 'incidentlist' }"></HeaderLeftContainer>

    <IncidentForm v-model="incident" @save="save" @cancel="cancel"></IncidentForm>
  </div>
</template>

<script setup lang="ts">
// Framework import
import { ref } from 'vue'

// Services import

// Types import

// Components import
import { useRouter } from 'vue-router'

import useLayers from '@tsyl/karonte/lib/composables/useLayers'
import type { Layer } from '@tsyl/karonte/lib/types/layers'
import type { ILayerWithFeatures } from '@tsyl/karonte/lib/wrappers/LayerInterfaces'

import HeaderLeftContainer from '@/components/HeaderLeftContainer.vue'
import IncidentForm from '@/components/Incident/IncidentForm.vue'
import { saveIncident } from '@/services/api/incidents'
import type { Incident } from '@/types/Incident'

const router = useRouter()
const { asyncGetLayerById } = useLayers()

const incident = ref<Partial<Incident>>({})

async function save() {
  try {
    await saveIncident(incident.value as Incident)
    const incidentsLayer = await asyncGetLayerById<Layer & ILayerWithFeatures>('incidents_layer')
    incidentsLayer?.refresh()
  } catch (e) {
    console.error(e)
  } finally {
    cancel()
  }
}

function cancel() {
  router.push({ name: 'incidentlist' })
}
</script>

<style scoped></style>
